import axios from 'axios';

interface PhoneNumbers {
  name: string;
  jnid: string;
}

class PhoneNumbersService {
  async getPhoneNumbers(
    engageOrigin: string,
    accessToken: string
  ): Promise<PhoneNumbers[]> {
    try {
      const response = await axios.get(`${engageOrigin}/api/v1/phone_numbers`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.data) {
        return [];
      }

      const phoneNumbers = response.data.map(({ title, number }) => ({
        name: title,
        jnid: number,
        phone: number,
      }));

      return phoneNumbers;
    } catch (error) {
      console.log('Error fetching phone numbers: ', error);
      return [];
    }
  }
}

export const phoneNumbersService = new PhoneNumbersService();
